import { Flex } from '@chakra-ui/react'
import EventBackround from '../EventBackround'
import { CrowdsColorPicker } from '../ui/CrowdsColorPicker'
import { useTranslation } from '../../i18n'

// Every section here takes `s`, the event's settings state — see
// `useSectionState` in EventWorkspaceContext.jsx for its shape.

export function ImagesSection({ s }) {
  const { t } = useTranslation()
  // Read-only shows the stored event; editing shows the draft, so a cancelled
  // image swap never lingers on screen.
  const data = s.editing ? s.draft : s.event
  const onChange = (value, field) => s.setField(field, value)
  return (
    <Flex gap={6} wrap="wrap">
      {!s.isHidden('challengeBackground') && <EventBackround name={t('events.challengeBackground')} eventData={data} imagePropName="backgroundUrl" colorPropName="backgroundColor" editing={s.editing} setImageFile={(f) => s.setFile('background', f)} handleBackgroundChange={onChange} />}
      {!s.isHidden('logo') && <EventBackround name={t('events.logo')} eventData={data} imagePropName="logoUrl" colorPropName="" editing={s.editing} setImageFile={(f) => s.setFile('logo', f)} handleBackgroundChange={onChange} />}
      {!s.isHidden('prizeBackground') && <EventBackround name={t('events.prizeBackground')} eventData={data} imagePropName="prizeBackgroundUrl" colorPropName="prizeBackgroundColor" editing={s.editing} setImageFile={(f) => s.setFile('prizeBackground', f)} handleBackgroundChange={onChange} />}
      {!s.isHidden('splash') && <EventBackround name={t('events.splashScreen')} eventData={data} imagePropName="splashUrl" colorPropName="" editing={s.editing} setImageFile={(f) => s.setFile('splash', f)} handleBackgroundChange={onChange} />}
    </Flex>
  )
}

const THEME_COLORS = [
  { field: 'colorBg', labelKey: 'events.backgroundColor', fallback: '#0f172a' },
  { field: 'colorSurface', labelKey: 'events.surfaceColor', fallback: '#1e293b' },
  { field: 'colorPrimary', labelKey: 'events.primaryColor', fallback: '#8b5cf6' },
  { field: 'colorText', labelKey: 'events.textColor', fallback: '#f1f5f9' },
]

export function ThemeSection({ s }) {
  const { t } = useTranslation()
  return (
    <Flex gap={4} wrap="wrap">
      {THEME_COLORS.map(({ field, labelKey, fallback }) => (
        <CrowdsColorPicker
          key={field}
          label={t(labelKey)}
          color={s.draft?.[field] ?? fallback}
          editing={s.editing}
          setColor={(color) => s.setField(field, color)}
          maxW={{ base: '100%', sm: '200px' }}
        />
      ))}
    </Flex>
  )
}
